import React from 'react';
import './Footer.scss';
import { useTranslation } from 'react-i18next';

const Footer = (props) => {
  const { t } = useTranslation();

  return (
    <div id="contacto" className='contenedor_footer'>
      <div className='contenedor_footer_social'>
        <a href="https://www.facebook.com/Velasur-by-Grupo-Velas-100278439225721/" target={'_blank'}>
          <img src="/assets/Logos/svg-icon-facebook.svg" alt="Facebook" />
        </a>
        <a href="https://instagram.com/velasur_qro?utm_medium=copy_link" target={'_blank'}>
          <img src="/assets/Logos/svg-icon-instagram.svg" alt="Instagram" />
        </a>
      </div>
      <div className='contenedor_footer_logo'>
        <a href="https://grupovelas.com.mx/" target={'_blank'}>
          <img src="/assets/Logos/svg-logo-grupo-velas.svg" alt="Grupo Velas" />
        </a>
      </div>
      <div className='contenedor_footer_tel'>
        <a href="tel:+524428801675" target={'_blank'}>
          {t('footer.phone')}
        </a>
      </div>
      <div className='contenedor_footer_info'>
        <p>
          © 2025 Grupo Velas ® {t('footer.rights')} |{' '}
          <a onClick={() => { props.setModalAviso(true) }}>
            {t('footer.privacyPolicy')}
          </a>
        </p>
        <p>{t('footer.disclaimer')}</p>
      </div>
    </div>
  );
};

export default Footer;
